import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class WardModel extends BaseModel {

    constructor() {
        super({
                name: "ward",
                tableName: 'ward',
                label: "Phường/xã",
                display_key: 'name',
                default_order: { key: 'name', direction: 'asc' }
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: "id",
                    display: false
                },
                state_id: {
                    name: "state_id",
                    display: false
                },
                district_id: {
                    name: "district_id",
                    display: false
                },
                name: { 
                    name: 'name',
                    type: "String",
                    label: 'Tên phường xã',
                    sortable: false,
                    width: 12,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Datetime",
                    label: 'Ngày cập nhật',
                    filter: {
                        type: "DateRange", match: "contrains",
                    },
                },

            },
            )
    }

}